import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import filter from 'lodash/fp/filter'
import isNil from 'lodash/fp/isNil'
import complement from 'lodash/fp/complement'

import CircularProgress from '../../components/CircularProgress'
import AutocompleteField from '../../components/FormFields/AutocompleteField'

const notNil = complement(isNil)
const removeNils = filter(notNil)

/**
 * Create an AutocompleteField that request for a resource list to make self options list
 *
 * @param {Object} options - options to make resource autocomplete
 * @param {(state, props) => Array} options.resourceSelector - selector to get resources list
 * @param {(state, props) => Boolean} options.requestingSelector - selector to get requesting state
 * @param {(props) => Any} options.fetcher - function to fetch resources called in component did mount
 * @param {(item) => String} [options.itemTextSelector] - function to pass as getItemText for AutocompleteField
 * @param {(item) => String} [options.itemValueSelector] - function to pass as getItemValue for AutocompleteField
 * @param {(Component) => EnhancedComponent} [options.withReducerEnhancer] - injectReducer hoc if needed
 * @param {(Component) => EnhancedComponent} [options.withSagaEnhancer] - injectSaga hoc if needed
 * @return {EnhancedResourceAutocomplete} connected component
 */
export default function resourceAutocomplete({
  resourceSelector,
  requestingSelector,
  fetcher,
  itemTextSelector,
  itemValueSelector,
  withReducerEnhancer,
  withSagaEnhancer
}) {
  class ResourceAutocomplete extends Component {
    static propTypes = {
      requesting: PropTypes.bool.isRequired,
      resources: PropTypes.array.isRequired
    }

    componentDidMount() {
      fetcher(this.props)
    }

    render() {
      const {
        requesting,
        resources,
        ...props
      } = this.props

      return (
        <AutocompleteField
          {...props}
          items={resources}
          icon={requesting && <CircularProgress size={20} />}
          getItemText={itemTextSelector}
          getItemValue={itemValueSelector}
        />
      )
    }
  }

  const mapStateToProps = createStructuredSelector({
    resources: resourceSelector,
    requesting: requestingSelector
  })
  const connector = connect(mapStateToProps)
  const enhancers = removeNils([
    withReducerEnhancer,
    withSagaEnhancer,
    connector
  ])
  const enhancer = compose(...enhancers)

  return enhancer(ResourceAutocomplete)
}
